import Badge from "@/components/Badge/Badge";
import { Button } from "@/components/Button/Button";
import Dialog from "@/components/Dialog/Dialog";
import { Icon } from "@/components/Icon";
import CDNImage from "@/components/Image/CDNImage";
import Slider, { SliderContext } from "@/components/Slider/Slider";
import ThumbnailSlider from "@/components/Slider/ThumbnailSlider";
import Tabs from "@/components/Tabs/Tabs";
import * as gtag from "@/lib/gtag";
import { DialogClose } from "@radix-ui/react-dialog";
import React, { useContext, useState } from "react";
import { Slot } from "utils/create-slots";
import { PageContext } from "pages/[[...slug]]";
import { createSlots } from "utils/create-slots";
import ButtonPhone from "@/components/ButtonPhone/ButtonPhone";

const Gallery = ({ assets, link, children, showStopper }) => {
  // const { name, subline, preis, rabatt, monatlicherate, internalid } = content;

  const [wishlistMobile] = createSlots(["wishlistMobile"], children);

  const [activeIdx, setActiveIdx] = useState(1);
  const handleIndexChange = (e) => {
    setActiveIdx(e.index + 1);
  };
  const handleMove = (e) => {
    gtag.event({
      event: "itemClick",
      itemClick: "picturesSlider",
      position: `${e.index + 1}`,
    });
  };

  return (
    <>
      <div className="relative mb-2 ">
        <div className="z-50">
          <div className="absolute   right-1/3 z-50 lg:block hidden">
            <Badge className="m-6">{activeIdx + 1} von 100</Badge>
          </div>
          <div className="absolute   right-2/3 z-50 lg:block hidden">
            <Badge className="m-6">{activeIdx} von 100</Badge>
          </div>
          <div className="absolute   right-0 z-50 lg:block hidden">
            <Badge className="m-6">{activeIdx + 2} von 100</Badge>
          </div>
        </div>

        <Slider
          onActive={handleIndexChange}
          onMove={handleMove}
          aria-label="Stage Slider"
          className="hidden lg:flex"
          options={{
            perPage: 3,
            perMove: 1,
            gap: "2px",
            pagination: false,
          }}
        >
          {assets.images.map((image, index) => (
            <BigPreviewImage
              key={index}
              image={image}
              index={index}
              showStopper={showStopper}
            />
          ))}
          <Slot name="arrows">
            <Slider.Arrows variant="blue" position="insideGallery" />
          </Slot>
        </Slider>
      </div>

      <div className="w-full md:w-[745px] lg:w-full mx-auto grid grid-cols-3 lg:grid-cols-6 gap-2">
        <div className="w-full col-span-3 lg:col-span-1 lg:hidden grid">
          <div className="w-full  grid grid-cols-1 relative">
            <CDNImage
              priority={true}
              src={assets.images[0]}
              quality={80}
              width={744}
              height={(744 / 4) * 3}
              alt="product img"
              sizesObj={{
                "(max-width: 1023px)": "100vw",
                "": "17vw",
              }}
            />
            {wishlistMobile}
          </div>
        </div>
        <Dialog
          showDefaultDialogClose={false}
          buttonClass="w-full flex relative"
          className="h-full lg:max-h-[95vh] !container  !mb-0 scrollbar-hide !p-0 "
          triggerLabel="Bilder Galerie"
        >
          {assets.images.slice(2, 8).map((image, index) => (
            <Slot name="trigger" key={index}>
              <div
                className={`
                  w-full h-full group 
                  ${index === 2 ? "block lg:hidden" : "hidden"}
                  ${index === 5 ? "hidden lg:block" : ""}
                `}
              >
                <div
                  className={`opacity-60 bg-gray-900 group-hover:opacity-50 z-20 absolute inset top-0 left-0 right-0 bottom-0`}
                  onClick={() => {
                    gtag.event({
                      event: "itemClick",
                      itemClick: "picturesGalery",
                      type: "Picture",
                      position: `${index + 2}`,
                    });
                  }}
                ></div>
                <div
                  className={`lg:text-4xl text-2xl absolute z-30 items-center top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-white `}
                >
                  +100
                </div>
              </div>
              <CDNImage
                className={`${
                  index >= 3 ? "hidden lg:flex" : ""
                } z-10 hover:opacity-80`}
                priority={true}
                alt="product img"
                src={image}
                width={246}
                quality={80}
                height={185}
                sizes={"(max-width: 1023px) 33vw, 16vw"}
              />
            </Slot>
          ))}

          <Slot name="content">
            <GalleryTabs assets={assets} ctaLink={link}>
              <DialogClose aria-label="Close">
                <Icon
                  type="close"
                  purposeLabel="Schliessen"
                  className="w-6 h-6 lg:top-5 top-5 right-5 text-primary absolute hover:text-blue-light"
                />
              </DialogClose>
            </GalleryTabs>
          </Slot>
        </Dialog>
      </div>
    </>
  );
};

export default Gallery;

const BigPreviewImage = ({ image, showStopper = false, index }) => {
  const { sliderRef } = useContext(SliderContext);

  const activeIndex = sliderRef?.current?.splide?.index || 0;

  const isPriority = !!(index >= activeIndex - 4 && index <= activeIndex + 8);

  return (
    <Slider.Slide>
      <div className="relative">
        <CDNImage
          priority={isPriority}
          alt="slider img"
          src={image}
          quality={80}
          width="495"
          height="371"
          sizes="(max-width: 1023px) 100vw, 33vw"
        />
      </div>
    </Slider.Slide>
  );
};

const GalleryTabs = ({ assets, children, ctaLink }) => {
  const { config } = useContext(PageContext);
  const [val, setVal] = useState(1);
  const [start, setStart] = useState(0);
  return (
    <Tabs.Root
      className="relative"
      onValueChange={(e) => setVal(e)}
      value={val}
    >
      <div
        className={`flex justify-between  sticky top-0  left-0 bg-white z-50 lg:w-full  min-h-[80px] `}
      >
        <Tabs.List className="flex gap-6 px-6  ">
          <Tabs.Trigger
            key={1}
            value={1}
            className={`active:text-blue-light text-gray-600   transition-colors group flex items-center font-bold lg:text-base text-sm`}
          >
            <Icon
              type="gallery"
              className="lg:w-8 lg:h-8 h-6 w-6 text-gray-600 mr-4 group-active:text-blue-light"
            />
            Galerie
          </Tabs.Trigger>
          <Tabs.Trigger
            key={2}
            value={2}
            className={`active:text-blue-light  text-gray-600 transition-colors  group flex  items-center font-bold lg:text-base text-sm`}
          >
            <Icon
              type="galleryDetail"
              className="lg:w-8 lg:h-8 h-6 w-6 text-gray-600 mr-4 group-active:text-blue-light"
            />
            Einzelansicht
          </Tabs.Trigger>
        </Tabs.List>
        {val === 2 && (
          <div className="ml-auto mr-[22.5%] my-auto  hd:mr-[20.5%] uhd:mr-[7.5%] lg:flex hidden ">
            <Button
              href={ctaLink}
              size="medium"
              as="a"
              className="cursor-pointer mr-6 max-h-[48px]"
              onClick={() => {
                gtag.event({
                  event: "itemClick",
                  itemClick: "Request",
                  itemPosition: "above",
                });
              }}
            >
              <Icon type="mail" className="w-6 h-6 mr-4" />
              Kauf anfragen
            </Button>
            <ButtonPhone
              className="max-h-[48px]"
              size="medium"
              config={config}
              itemPosition="picturesGalery"
            />
          </div>
        )}
        {children}
      </div>
      <Tabs.Content key={1} value={1}>
        <GalleryImageGrid assets={assets} setVal={setVal} setStart={setStart} />
      </Tabs.Content>
      <Tabs.Content
        key={2}
        value={2}
        className="lg:max-w-[80%] xl:max-w-[50%] 2xl:max-w-[75%]  hd:max-w-[1300px] mx-auto mt-6"
      >
        <ThumbnailSlider
          assets={assets}
          start={start}
          nonBindingRequestLink={ctaLink}
        />
      </Tabs.Content>
    </Tabs.Root>
  );
};

const GalleryImageGrid = ({ assets, setVal, setStart }) => {
  return (
    <div className=" grid lg:grid-cols-3 grid-cols-2 gap-6 grid-rows-[min-content_1fr] min p-6 w-full h-full [&>*:nth-child(3n)]:col-span-2 lg:[&>*:nth-child(3n)]:col-span-1">
      {assets.images.map((image, index) => {
        // const bigImages: number[] = [
        //   3, 9, 16, 21, 27, 39, 45, 51, 57, 63, 75, 81, 87, 93,
        // ];
        const bigImages: number[] = [
          0, 7, 12, 19, 24, 31, 36, 43, 48, 55, 60, 67, 72, 79, 84, 91, 96,
        ];
        const isBig = bigImages.includes(index);
        return (
          <div
            className={` w-full h-full object-cover overflow-hidden   ${
              isBig ? " lg:!col-span-2  lg:row-span-2 " : "lg:!col-span-1"
            }`}
            key={index}
            onClick={() => {
              setVal(2);
              setStart(index);
            }}
          >
            <CDNImage
              priority={index < 9}
              quality={100}
              key={index}
              className="w-full h-full object-cover cursor-pointer hover:shadow-md hover:scale-110 hover:drop-shadow-2xl"
              alt="product img"
              src={image}
              width={isBig ? 382 * 2 + 12 : 382}
              height={isBig ? ((382 * 2) / 4) * 3 + 12 : (382 / 4) * 3}
              sizesObj={{
                "(max-width: 639px)": `${isBig ? 192 * 2 + 12 : 192}px`,
                "(max-width: 1023px)": `${isBig ? 252 * 2 + 12 : 252}px`,
                "": `${isBig ? 382 * 2 + 12 : 382}px`,
              }}
            />
          </div>
        );
      })}
    </div>
  );
};
